function resolveHSLColor(value) {
    if (!value) {
        return undefined;
    }
    return `hsl(var(--color-${value}))`;
}
function resolveHSLAColor(value, alpha) {
    if (!value || !alpha) {
        return undefined;
    }
    return `hsla(var(--color-${value}), ${alpha})`;
}
function getColorBlackOrWhite(value) {
    if (!value) {
        return undefined;
    }
    const darkShades = ['50', '55', '60', '65', '70', '75', '80', '85', '90'];
    const isWhite = ['black', 'safety-red', 'safety-vigilance'].includes(value)
        || value.includes('gray-3')
        || value.includes('gray-4')
        || darkShades.some(shade => value.endsWith(shade));
    return resolveColor(isWhite ? 'white' : 'black');
}
function resolveBackgroundColor(value) {
    return {
        ...getColorBlackOrWhite(value),
        backgroundColor: resolveHSLColor(value),
    };
}
function resolveColor(value) {
    return { color: resolveHSLColor(value) };
}
export { resolveBackgroundColor, resolveColor, resolveHSLColor, resolveHSLAColor, };
//# sourceMappingURL=color-resolver.js.map